import { divideAccuracy, formatLang } from "@/lobby_common/utils/utils.js";
import { getAnyZoneTime } from "@/lobby_common/utils/date";
import { formatTimedown } from "@/lobby_common/utils/utils";
import {
  betRankCurrent,
  betRankHistory,
  betRankCurrentNoAuth,
  betRankHistoryNoAuth,
  teamBetRankCurrent,
  teamBetRankHistory,
  teamBetRankCurrentNoAuth,
  teamBetRankHistoryNoAuth,
  teamBetRankDetail,
  teamBetRankRankRewardDetail,
} from "@/lobby_common/api/activity_gen.js";
import { getMedalList } from "@/lobby_common/api/medal_gen.js";
import jiangbei from "@/assets/rankList/jiangbei.png";
import tuandui from "@/assets/rankList/tuandui.png";
import maisui1 from "@/assets/rankList/maisui1.png";
import maisui2 from "@/assets/rankList/maisui2.png";
import jiaobiao from "@/assets/rankList/jiaobiao.png";
import huangguan from "@/assets/rankList/huangguan.png";
import benqi from "@/assets/rankList/benqi.png";
export default {
  name: "RankMode2",
  props: {
    isShowRank: {
      type: Boolean,
      default: true,
    },
    dataOpt: {
      type: [Object],
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      divideAccuracy,
      formatLang,
      jiangbei,
      maisui1,
      maisui2,
      jiaobiao,
      huangguan,
      benqi,
      tuandui,
      tableData: [],
      tableData2: [],
      tableData3: [],
      tableDataPrev: [], // 上期
      dataObj: {},
      surplusTime: undefined,
      surplusHour: "", // 剩余多少小时
      surplusMin: "", // 剩余多少分钟
      surplusSec: "", // 剩余多少秒
      timer: null,
      PopupWindowShow: false,
      PopupWindowShowPrev: false,
      PopupWindowShowtuandui1: false,
      PopupWindowShowtuandui2: false,
      // curTips: '',
      active: 1, // 1个人 2团队
      options: [],
      timeCycle: 0,
      page: 1,
      pageSize: 10,
      teamNum: 0,
      medalList: [],
      isMedalOpen: false,
      lastRank: 0,
    };
  },
  watch: {
    "$route.query.index": {
      handler(index) {
        if (index) {
          this.active = Number(index);
        } else {
          if (
            this.$store.getters.getAllEnableFeature?.activityTypes.includes(
              "ActivityTypeRank"
            )
          ) {
            this.active = 1;
          } else if (
            this.$store.getters.getAllEnableFeature?.activityTypes.includes(
              "ActivityTypeTeamRank"
            )
          ) {
            this.active = 2;
          }
        }
      },
      immediate: true, // 组件加载时立即执行一次
      deep: true, // 若 query 是对象并需要深度监听
    },
  },
  computed: {
    // 个人排行榜
    personalRanking() {
      return this.$store.getters.getAllEnableFeature?.activityTypes.includes(
        "ActivityTypeRank"
      );
    },
    hasMoreMedal() {
      return this.medalList.length > 6;
    },
    showMedalList() {
      if (this.hasMoreMedal) {
        return this.medalList.slice(0, 5);
      }
      return this.medalList;
    },
    showMedalBox() {
      return (
        this.personalRanking &&
        this.active === 1 &&
        this.isMedalOpen &&
        this.taken &&
        this.medalList.length
      );
    },
    taken() {
      return this.$store.getters.taken;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    // 用户信息
    userInfo() {
      return this.$store.getters.user;
    },
    // 应用信息
    appConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    coinSymbol() {
      if (this.taken) {
        return this.userInfo.coinSymbol;
      } else {
        return this.appConfig.symbol;
      }
    },
    coinAccuracy() {
      if (this.taken) {
        return this.userInfo.accuracy;
      } else {
        return this.appConfig.accuracy;
      }
    },
    curTips() {
      // 根据当前排名来显示提示信息
      let curTipsTxt = "";
      if (this.taken) {
        const num = this.dataObj.needBet;
        const stxt =
          this.coinSymbol +
          " " +
          this.divideAccuracy(num, this.coinAccuracy, true);
        if (!this.dataObj.selfRank) {
          curTipsTxt = this.formatLang(this.$t("Datalang.home_You_need"), [
            stxt,
          ]);
        }
        if (this.dataObj.selfRank && this.dataObj.selfRank === 1) {
          curTipsTxt = this.$t("Datalang.newly_keep_betting");
        }
        if (this.dataObj.selfRank && this.dataObj.selfRank > 1) {
          curTipsTxt = this.formatLang(this.$t("Datalang.home_Distance_from"), [
            stxt,
          ]);
        }
      } else {
        curTipsTxt = "";
      }
      return curTipsTxt;
    },
    lastDisabled: function () {
      return this.page === 1;
    },
    nextDisabled: function () {
      return this.tableData2.length !== this.pageSize;
    },
    showTab() {
      return (
        this.$store.getters.getAllEnableFeature?.activityTypes.includes(
          "ActivityTypeRank"
        ) &&
        this.$store.getters.getAllEnableFeature?.activityTypes.includes(
          "ActivityTypeTeamRank"
        )
      );
    },
  },
  created() {
    // if (this.$store.getters.getAllEnableFeature?.activityTypes.includes('ActivityTypeRank')) {
    //   this.active = 1;
    // } else if (this.$store.getters.getAllEnableFeature?.activityTypes.includes('ActivityTypeTeamRank')) {
    //   this.active = 2;
    // }
    if (this.dataOpt?.position) {
      this.$eventPost("dama_rank_popup", {
        SubRankings: this.dataOpt.position,
      });
    } else {
      this.$eventPost("dama_rank_popup");
    }
  },
  mounted() {
    this.getTableList();

    if (
      this.$store.getters.getAllEnableFeature?.activityTypes.includes(
        "ActivityTypeTeamRank"
      )
    ) {
      this.getTeamBetRankRankRewardDetail();
      this.getTeamBetRankDetail();
    }
    // 获取勋章数据
    if (this.taken) {
      this.fetchMedalList();
    }
  },
  methods: {
    async fetchMedalList() {
      try {
        const { code, data } = await getMedalList({
          preview: true,
        });
        if (code === 0) {
          // 是否开启
          if (data?.isMedalEnabled) {
            this.isMedalOpen = true;
          }
          this.medalList = data?.medalList || [];
          this.lastRank = data?.lastRank || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    showMedal() {
      this.$eventPost("betting_rank_more_click");
      this.$refs.medalDialog.showMedal();
    },
    showMedalExchange() {
      this.$eventPost("betting_rank_exchange_click");
      this.$refs.medalDialog.showExchange();
    },
    async handleTab(tab) {
      this.active = tab;
      this.clearSome();
      this.getTableList(tab);
      if (this.taken && tab === 1) {
        this.fetchMedalList();
      }
    },
    clearSome() {
      this.dataObj = {};
      this.tableData = [];
      clearInterval(this.timer);
      this.timer = null;
      this.surplusHour = "";
      this.surplusMin = "";
      this.surplusSec = "";
    },
    // 上一页
    lastPage() {
      if (this.page === 1) {
        this.sid = 0;
        return;
      }
      if (!this.tableData2.length) {
        this.pageType = "PAGE_TYPE_NEXT";
        const arr = this.pageData[this.page - 2] || []; // 如果刚好最后一页的数据为null    然后点击上一页查询  需要传入上上一页的最后一条数据的sid  同时查询方向改为下一页类型
        this.page = this.page - 1;
        const obj = arr[arr.length - 1] || {};
        this.sid = obj.sid || 0;
      } else {
        this.pageType = "PAGE_TYPE_PREVIOUS";
        this.page = this.page - 1;
        const obj = this.tableData2[0];
        this.sid = obj.sid || 0;
      }
      // this.fetchFlowList();
    },
    // 下一页
    nextPage() {
      this.pageType = "PAGE_TYPE_NEXT";
      this.page = this.page + 1;
      const obj = this.tableData2[this.tableData2.length - 1];
      this.sid = obj.sid || 0;
      // this.fetchFlowList();
    },
    async getTableList(tab) {
      const api1 = this.$store.getters.taken
        ? betRankCurrent
        : betRankCurrentNoAuth;
      const api2 = this.$store.getters.taken
        ? teamBetRankCurrent
        : teamBetRankCurrentNoAuth;
      const active = tab || this.active;
      const dataApi = active === 1 ? api1 : api2;
      const { code, data } = await dataApi();
      if (code === 0) {
        if (active !== this.active) {
          return;
        }
        this.dataObj = data || {};
        this.tableData = this.dataObj.list || [];

        if (
          this.active === 1 &&
          this.dataObj.displayNextCycle === "STATUS_BOOL_TRUE"
        ) {
          this.tableData = await this.getRankPrev();
        }
        // 开始倒计时
        this.surplusTime = Number(this.dataObj.remainingTime);
        if (this.surplusTime && this.surplusTime > 0) {
          this.getTime();
        }

        if (this.dataObj.selfRank) {
          if (this.dataObj.selfRank === 1) {
            this.dataObj.selfRankTxt = this.dataObj.selfRank + "" + "st";
          }
          if (this.dataObj.selfRank === 2) {
            this.dataObj.selfRankTxt = this.dataObj.selfRank + "" + "nd";
          }
          if (this.dataObj.selfRank === 3) {
            this.dataObj.selfRankTxt = this.dataObj.selfRank + "" + "rd";
          }
          if (this.dataObj.selfRank > 3) {
            this.dataObj.selfRankTxt = this.dataObj.selfRank + "" + "th";
          }
        }
      }
    },
    // 倒计时
    getTime() {
      // 美东 -4时间
      // const _this = this
      if (this.timer === null) {
        this.timer = setInterval(() => {
          this.surplusTime = this.surplusTime - 1;
          if (!this.surplusTime || this.surplusTime < 0) {
            clearInterval(this.timer);
            this.timer = null;
            setTimeout(() => {
              this.getTableList();
            }, 5000);
          }
          // 还剩多少小时
          const hours = Math.floor(this.surplusTime / 3600);
          this.surplusHour = hours > 0 ? hours : "00";
          // 剩余时间
          const surplusTime = this.surplusTime % 3600;
          const surplusTxt = formatTimedown(surplusTime, 0);
          this.surplusMin = surplusTxt.substring(3, 5);
          this.surplusSec = surplusTxt.substring(6, 8);
        }, 1000);
      }
    },
    goLogin() {
      this.$Bus.$emit("showLogin", { tab: "Login" });
    },
    // 上一期
    async handleRankPrev() {
      const api1 = this.$store.getters.taken
        ? betRankHistory
        : betRankHistoryNoAuth;
      const api2 = this.$store.getters.taken
        ? teamBetRankHistory
        : teamBetRankHistoryNoAuth;
      const dataApi = this.active === 1 ? api1 : api2;
      const { code, data } = await dataApi();
      if (code === 0) {
        this.tableDataPrev = data?.list || [];
        this.PopupWindowShowPrev = true;
      }
    },
    // 获取上一期数据
    async getRankPrev() {
      const api1 = this.$store.getters.taken
        ? betRankHistory
        : betRankHistoryNoAuth;
      const api2 = this.$store.getters.taken
        ? teamBetRankHistory
        : teamBetRankHistoryNoAuth;
      const dataApi = this.active === 1 ? api1 : api2;
      const { code, data } = await dataApi();
      if (code === 0) {
        return data?.list || [];
      }
    },
    async getTeamBetRankDetail() {
      if (!this.taken) return;
      const { code, data } = await teamBetRankDetail({
        page: this.page,
        pageSize: this.pageSize,
        startTime: this.timeCycle,
      });
      if (code === 0) {
        this.tableData2 = data?.teamList || [];
        this.teamNum = data?.teamNum;
        const arr = data?.cycleList || [];
        this.options = arr.map((i) => {
          return {
            label:
              getAnyZoneTime(Number(i.startTime * 1000), "yyyy/MM/dd") +
              "-" +
              getAnyZoneTime(Number(i.endTime * 1000), "yyyy/MM/dd"),
            value: Number(i.startTime),
          };
        });
        this.timeCycle = this.timeCycle || this.options[0]?.value;
      }
    },
    async getTeamBetRankRankRewardDetail() {
      if (!this.taken) return;
      const { code, data } = await teamBetRankRankRewardDetail({
        page: 1,
        pageSize: 999,
      });
      if (code === 0) {
        this.tableData3 = data?.list || [];
      }
    },
    timeCycleChange(val) {
      this.page = 1;
      this.timeCycle = val;
      this.getTeamBetRankDetail();
    },
    showTuandui1() {
      this.PopupWindowShowtuandui1 = true;
      this.page = 1;
      this.timeCycle = 0;
      this.getTeamBetRankDetail();
    },
    async showTuandui2() {
      if (!this.taken) {
        this.goLogin();
        return;
      }
      this.PopupWindowShowtuandui2 = true;
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
};
